import React, { useState, useRef, useEffect } from 'react';

function IngredientAutocomplete({ value, pantryList, onChange, onAccept, placeholder, t }) {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [highlightIndex, setHighlightIndex] = useState(0);
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);

  const query = value.toLowerCase().trim();
  const filtered = query.length > 0
    ? pantryList
        .filter((n) => n.toLowerCase().includes(query))
        .sort((a, b) => {
          const aStarts = a.toLowerCase().startsWith(query) ? 0 : 1;
          const bStarts = b.toLowerCase().startsWith(query) ? 0 : 1;
          if (aStarts !== bStarts) return aStarts - bStarts;
          return a.localeCompare(b);
        })
    : [];

  const accept = (val) => {
    onChange(val);
    setShowSuggestions(false);
    setHighlightIndex(0);
    if (onAccept) onAccept();
  };

  const handleKeyDown = (e) => {
    if (!showSuggestions || filtered.length === 0) {
      if (e.key === 'Tab' && !e.shiftKey && filtered.length > 0 && query.length > 0) {
        e.preventDefault();
        accept(filtered[0]);
        return;
      }
      return;
    }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightIndex((prev) => Math.min(prev + 1, filtered.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === 'Tab' || e.key === 'Enter') {
      e.preventDefault();
      accept(filtered[highlightIndex]);
    } else if (e.key === 'Escape') {
      setShowSuggestions(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    setHighlightIndex(0);
  }, [value]);

  return (
    <div className="ing-autocomplete-wrapper" ref={wrapperRef}>
      <input
        ref={inputRef}
        className="inline-ing-name"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          setShowSuggestions(true);
        }}
        onFocus={() => { if (query.length > 0 && filtered.length > 0) setShowSuggestions(true); }}
        onKeyDown={handleKeyDown}
      />
      {showSuggestions && filtered.length > 0 && (
        <div className="ing-suggestions">
          {filtered.slice(0, 8).map((item, i) => (
            <div
              key={item}
              className={`ing-suggestion-item${i === highlightIndex ? ' highlighted' : ''}`}
              onMouseDown={() => accept(item)}
              onMouseEnter={() => setHighlightIndex(i)}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default IngredientAutocomplete;
